import { User } from "lucide-react";
import React, { useState, useEffect } from "react";

interface UserData {
  id: number;
  name: string;
  email: string | null;
  category: string | null;
  role: string;
}

const UserSection = () => {
  const [userData, setUserData] = useState<UserData | null>(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  if (!userData) {
    return (
      <div className="flex items-center space-x-3 p-3 rounded-lg">
        <div className="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center shrink-0 animate-pulse">
          <User className="w-4 h-4 text-slate-600" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="h-4 bg-slate-200 rounded animate-pulse mb-1"></div>
          <div className="h-3 bg-slate-200 rounded animate-pulse w-2/3"></div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-50 transition-colors cursor-pointer border border-transparent hover:border-blue-200">
        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center shrink-0">
          <User className="w-4 h-4 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-blue-900 truncate leading-tight">
            {userData.name}
          </p>
          {userData?.email && (
            <p className="text-xs text-blue-600 truncate leading-tight mt-0.5">
              {userData.email}
            </p>
          )}
          {userData?.role && (
            <p className="text-xs text-blue-500 truncate leading-tight mt-0.5 capitalize">
              {userData.role}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserSection;
